import { useCallback, useState } from 'react';

export const useRootRef = (
  cb?: (element: HTMLDivElement) => void,
  deps: any[] = []
) => {
  const [element, setElement] = useState<HTMLDivElement | null>(null);
  const rootRef = useCallback(
    (element: HTMLDivElement) => {
      setElement(element);

      cb?.(element);
    },
    [...deps]
  );
  return { element, rootRef };
};
